import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch} from 'vue-property-decorator';
import debounce from 'core/decorators/debounce';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        Vnodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes
        }
    }
})
export class StoryCarouselComponent extends Vue {
    @Prop()
    breakpoint: string;

    currentStory: number = 0;
    gapWidth: number = 30;
    currentStoryIndex: number = 0;
    slidesWidth: number[] = [];
    
    get isNextStoryAvaliable(): boolean{
        return this.currentStoryIndex < this.slidesWidth.length - this.numberAvaliableSlides;
    }

    get isPrevStoryAvaliable(): boolean{
        return this.currentStoryIndex > 0;
    }
    
    get numberAvaliableSlides() {
        if(window.innerWidth < 991){
            return 2;
        }
        if(window.innerWidth < 1200){
            return 3;
        }
        return 4;
    }

    get carouselOffset(){
        return this.slidesWidth?.reduce((a,c,i)=>{
            if(this.currentStoryIndex > i ){
                return c + a;
            } else {
                return a;
            }
        },0);
    }
    
    mounted() {     
        this.getSlidesWidth();
    }

    getProductIcon(iconName: string): string {
        const urlPrefix = '/i/icons/lg/';

        return urlPrefix + iconName + '.svg';
    }

    getSlidesWidth() {
        const wrapper = (<any>this).$refs.storyCarousel;

        for(let i = 0; i < wrapper?.children?.length; i++){
            this.slidesWidth.push(wrapper.children[i].clientWidth);
        }
    }

    nextStory(){
        if (this.isNextStoryAvaliable){ 
            this.currentStoryIndex++;
        }
    }

    prevStory(){
        if (this.isPrevStoryAvaliable){
            this.currentStoryIndex--;
        }
    }

    onProductDetails(){
        (<any>this).$refs.modalProductDetails.isActive = true;
        (<any>this).$ga.sendEvent('banner', 'click', 'banner.cliсk.product.kit62.id15');
    }
}